function errorHandler(error){
const modalInfo= {type: "error" , message: "", code: null }

if(error instanceof TypeError){
    modalInfo.message = "Erro de conexão. Por favor, tente novamente mais tarde ou entre em contato com o administrador."
} else {

    modalInfo.code = error.code
    switch(error.code){
        case 400:
        case 409:
            modalInfo.type = "warning"
            modalInfo.message = error.message
            break;
        case 401:
            modalInfo.type= "warning";
            modalInfo.message = "Credenciais inválidas. Por favor, tente novamente.";
            break;
        case 403:
            modalInfo.type = "warning";
            modalInfo.message = "Operação não autorizada: o usuário não possui as permissões necessárias."
            break;
        case 500: 
             modalInfo.message = "Ocorreu um erro inesperado. Por favor, entre em contato com o administrador.";
            break;
         default:
            modalInfo.message = "Ocorreu um erro inesperado. Por favor, entre em contato com o administrador.";
            break;
}
}

return modalInfo

}

export {errorHandler}